import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRenderJobs } from '../context/RenderJobsContext';

export const RenderJobsToast = () => {
  const navigate = useNavigate();
  const { jobs, dismissJob, previewFile, setPreviewFile } = useRenderJobs();

  return (
    <>
      {jobs.length > 0 && (
        <div className="fixed bottom-4 right-4 z-40 space-y-2 max-w-sm">
          {jobs.map(job => (
            <div
              key={job.id}
              className={`bg-surface border rounded-xl shadow-lg p-3 flex items-center gap-3 ${
                job.status === 'error' ? 'border-danger' : 'border-line'
              }`}
            >
              {job.status === 'rendering' && (
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-ink flex-shrink-0" />
              )}
              {job.status === 'done' && (
                <div className="w-6 h-6 rounded-full bg-success text-white flex items-center justify-center text-xs flex-shrink-0">✓</div>
              )}
              {job.status === 'error' && (
                <div className="w-6 h-6 rounded-full bg-danger text-white flex items-center justify-center text-xs flex-shrink-0">!</div>
              )}
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-ink truncate">
                  {job.status === 'rendering' && `Rendering ${job.name || 'video'}…`}
                  {job.status === 'done' && (job.name || 'Render complete')}
                  {job.status === 'error' && 'Render failed'}
                </div>
                {job.status === 'error' && (
                  <div className="text-[10px] text-danger truncate">{job.error}</div>
                )}
                {job.status === 'rendering' && (
                  <div className="text-[10px] text-ink-muted">Keep working — we'll notify you</div>
                )}
                {job.status === 'done' && job.file && (
                  <button
                    onClick={() => setPreviewFile(job.file)}
                    className="text-[10px] text-info hover:underline"
                  >
                    Preview video
                  </button>
                )}
              </div>
              <button
                onClick={() => dismissJob(job.id)}
                className="text-ink-muted hover:text-ink text-sm flex-shrink-0"
                title="Dismiss"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Preview Modal */}
      {previewFile && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-4" onClick={() => setPreviewFile(null)}>
          <div className="bg-surface rounded-xl max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-3 border-b border-line">
              <h3 className="font-semibold text-sm truncate">{previewFile.filename}</h3>
              <button onClick={() => setPreviewFile(null)} className="text-lg leading-none">✕</button>
            </div>
            <div className="bg-black flex items-center justify-center" style={{ minHeight: '40vh' }}>
              <video src={previewFile.url} controls autoPlay className="max-w-full max-h-[60vh]" />
            </div>
            <div className="p-3 border-t border-line flex justify-end gap-2">
              <button
                onClick={() => { setPreviewFile(null); navigate('/media'); }}
                className="px-3 py-1.5 text-xs border border-line rounded hover:border-line-strong min-h-[var(--tap-target)] sm:min-h-0"
              >
                Open in Media Library
              </button>
              <button
                onClick={() => setPreviewFile(null)}
                className="px-3 py-1.5 text-xs bg-accent text-accent-ink rounded min-h-[var(--tap-target)] sm:min-h-0"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
